export const FlipColor = (str) => {
    if(str.includes('light')) {
        return str.replace('light', 'dark');
    }else if(str.includes('dark')) {
        return str.replace('dark', 'light');
    }else{
        return str;
    }
}